import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-dvh place-items-center px-4 text-center">
      <div>
        <p className="font-display text-6xl text-accent">404</p>
        <h1 className="mt-2 text-2xl text-foreground">{t('common.notFound')}</h1>
        <Link to="/" className="mt-6 inline-block text-sm text-accent underline">
          {t('common.backHome')}
        </Link>
      </div>
    </div>
  );
}
